module.exports = __webpack_public_path__ + "static/media/E31.7b15bf74.png";